<template>
  <div class="hero-wrapper" id="hero">
    <VideoSection v-if="bannerIsVideo" />
    <SliderSection v-else />
  </div>
  <CyanUpdates/>
  <div class="background-container">
    
    <svg class="wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
      <path fill="#1268B1" fill-opacity="1" d="M0,128L48,138.7C96,149,192,171,288,181.3C384,192,480,192,576,176C672,160,768,128,864,144C960,160,1056,224,1152,229.3C1248,235,1344,181,1392,160L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
    </svg>
    <div class="container">
      <div class="card-container">
        <div class="card" v-for="(card, index) in cards" :key="index" :class="`card-${index + 1}`" data-aos="fade-up">
          <div class="card-content">
            <div class="card-icon">
              <i :class="card.icon"></i>
            </div>
            <h3 class="text-white">{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
          <div class="wave-bottom">
            <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none">
              <defs>
                <path id="wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
              </defs>
              <g class="wave-parallax">
                <use xlink:href="#wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
                <use xlink:href="#wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                <use xlink:href="#wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                <use xlink:href="#wave" x="48" y="7" fill="rgba(255,255,255,0.2)" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import VideoSection from '../components/VideoSection.vue';
import SliderSection from '../components/SliderSection.vue';
import CyanUpdates from './Home/CyanUpdates.vue';

const bannerIsVideo = ref(false);

const cards = ref([
  {
    title: 'Location',
    description: '4740 طريق الملك، جدة 23829, Saudi Arabia.',
    icon: 'fas fa-map-marker-alt',
  },
  {
    title: 'Opening Times',
    description: 'Wednesday to Saturday from 11:00 AM to 7:00 PM.',
    icon: 'fas fa-clock',
  },
  {
    title: 'Contact Us',
    description: 'Phone: +966123456789',
    icon: 'fas fa-phone-alt',
  },
  {
    title: 'Services',
    description: 'Explore our wide range of services.',
    icon: 'fas fa-cogs',
  },
]);
</script>

<style scoped>
/* Hero Section */
.hero-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  z-index: 10;
  background: #f5f5f5;
  overflow: hidden;
}

/* Background Container */
.background-container {
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
  padding-bottom: 100px;
  min-height: 100vh;
  background-image: url('/public/assets/img/footer-clip.png');
  background-position: bottom right;
  background-size: 30%;
  background-repeat: no-repeat;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Card Container */
.card-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  padding-top: 150px;
  position: relative;
  z-index: 2;
}

/* Card Styles */
.card {
  position: relative;
  height: 300px;
  background: #1268B1;
  color: #fff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-content {
  position: relative;
  z-index: 2;
  padding: 30px;
  height: calc(100% - 60px); /* Adjust for wave height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Wave Bottom */
.wave-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  overflow: hidden;
}

.waves {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-width: 600px;
}

.wave-parallax > use {
  animation: move-forever 12s linear infinite;
}

.wave-parallax > use:nth-child(1) {
  animation-delay: -2s;
}

.wave-parallax > use:nth-child(2) {
  animation-delay: -4s;
  animation-duration: 10s;
}

.wave-parallax > use:nth-child(3) {
  animation-delay: -6s;
  animation-duration: 8s;
}

.wave-parallax > use:nth-child(4) {
  animation-delay: -8s;
  animation-duration: 6s;
}

@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}

/* Card Icon */
.card-icon {
  margin: 0 auto 20px;
  width: 80px;
  height: 80px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.card-icon i {
  font-size: 28px;
  color: #003d73;
}

/* Text Styles */
.card h3 {
  font-size: 24px;
  margin-bottom: 15px;
  text-align: center;
}

.card p {
  font-size: 16px;
  color: #d0d0d0;
  text-align: center;
  margin: 0;
}

/* Hover Effects */
.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.card:hover .card-icon {
  transform: scale(1.1) rotate(5deg);
}

/* Responsive Design */
@media (max-width: 768px) {
  .card-container {
    grid-template-columns: 1fr;
  }
  
  .card {
    height: 250px;
  }

  .wave-bottom {
    height: 40px;
  }

  .card-content {
    height: calc(100% - 40px);
  }

  .card-icon {
    width: 60px;
    height: 60px;
  }

  .card-icon i {
    font-size: 24px;
  }

  .card h3 {
    font-size: 20px;
  }

  .card p {
    font-size: 14px;
  }
}

/* Main Wave Animation */
.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 0;
  animation: mainWaveFloat 3s ease-in-out infinite alternate;
}

@keyframes mainWaveFloat {
  from {
    transform: translateY(0) scaleY(1);
  }
  to {
    transform: translateY(10px) scaleY(1.3);
  }
}
</style>